import ModalItem from './ModalItem';

export default ModalItem;
